"use strict";

const style = require('!!css-loader?{"sourceMap":false}!postcss-loader!./style/index.css').default;

module.exports =`
    <style>${style}</style>
    <label class="swiftref-checkbox-label">
           <input type="checkbox" class="swiftref-checkbox"> 
    </label>
    <swiftref-message state="error"></swiftref-message>
`;
